// hideBtnActionPlugin.js
export default {
  install(app, options = {}) {
    const { selector = '.btnActionPermission', debounce = 50 } = options

    const removeElements = () => {
      document.querySelectorAll(selector).forEach((el) => el.remove())
    }

    // Roda imediatamente após um pequeno delay
    setTimeout(removeElements, debounce)

    // Observa todas mudanças no DOM
    const observer = new MutationObserver(() => removeElements())
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    // Roda também após cada mudança de rota
    if (app.config.globalProperties.$router) {
      app.config.globalProperties.$router.afterEach(() => removeElements())
    }
  },
}
